import { useSelector } from "react-redux";
import Base from "../../modules/Base";
import Login from "../../modules/auth/Login";

const AuthMiddleware = ({ children }) => {
    const token = useSelector((state) => state.auth.token)

    return (
        token != null ? <Base>
            {children}
        </Base> : <Login />
    )
}

export default AuthMiddleware
